<template>
  <div class="card p-shadow-app" :style="{ position: 'relative' }">
    <div class="agenda-summary">
      <H4>Agenda</H4>
      <span v-if="calculatingDistance" class="p-tag p-tag-warning" role="status">
        <i class="pi pi-spin pi-spinner p-mr-1"></i> A calcular km...
      </span>
      <span v-else-if="totalDistanceKm !== null" class="p-tag p-tag-info agenda-distance"
        :title="`${distanceIsEstimate ? 'Estimativa em linha reta (rota indisponível)' : 'Distância por estrada'} · Partida e regresso: ${baseLocation.name}`">
        <i class="pi pi-car p-mr-1"></i> Total aprox. {{ totalDistanceKm }} km
        <small>
          ({{ baseLocation.name }}: partida e regresso{{ distanceIsEstimate ? ', estimativa' : '' }})
        </small>
      </span>
      <span v-if="missingCoordsCount" class="p-tag p-tag-warning">
        {{ missingCoordsCount }} intervenção(ões) sem coordenadas, não incluída(s).
      </span>
    </div>
    <div>
      <Message v-if="requireReservation" severity="warn" :closable="false" class="agenda-reservation-message">
        Para iniciar a deslocação, reserve um veículo ou registe um veículo de aluguer.
        <Button label="Reservar veículo" icon="pi pi-car" class="p-button-text p-button-sm"
          @click="showAllVehicles = true" />
      </Message>
      <Message v-if="reservationError" severity="error" :closable="false" class="agenda-reservation-message">
        {{ reservationError }}
      </Message>
    </div>
    <Loading :active.sync="isLoading" :is-full-page="false"></Loading>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" group="taskList" />
    <ConfirmDialog />

    <ConfirmEquipamentData
      :show="showConfirmDataForm"
      :service="service"
      v-on:close="
        () => {
          showConfirmDataForm = false;
          return (service = null);
        }
      "
      v-on:updatedData="changedStatus"
    />
    <EquipamentPhotos
      :show="showFotosForm"
      :service="service"
      v-on:close="
        () => {
          showFotosForm = false;
          return (service = null);
        }
      "
      v-on:sendedPhotos="changedStatus"
    />
    <ExtraPhoto
      :show="showExtraFotosForm"
      :service="service"
      v-on:close="
        () => {
          showExtraFotosForm = false;
          return (service = null);
        }
      "
      v-on:sendedExtraPhotos="
        () => {
          showExtraFotosForm = false;
          return (service = null);
        }
      "
    />
    <InterventionInfo
      :show="showInfo"
      :service="service"
      v-on:close="
        () => {
          showInfo = false;
          return (service = null);
        }
      "
    />
    <AddPart
      :show="showAddPartForm"
      :service="service"
      v-on:close="
        () => {
          showAddPartForm = false;
          return (service = null);
        }
      "
      v-on:addedPart="
        () => {
          showAddPartForm = false;
          return (service = null);
        }
      "
    />
    <WorkSheet
      :show="workSheet.show"
      :task_id="workSheet.taskId"
      v-on:close="
        () => {
          return (this.workSheet = {
            show: false,
            taskId: null,
            newStatus: null,
          });
        }
      "
      v-on:confirmedWorkSheet="
        () => {
          workSheet.show = false;
          return endService();
        }
      "
    />
    <SignaturePadReport
      :show="showSignaturePadReportForm"
      :service="service"
      v-on:close="
        () => {
          showSignaturePadReportForm = false;
          return (service = null);
        }
      "
      v-on:savedSignature="
        () => {
          showSignaturePadReportForm = false;
          calendarApi.refetchEvents();
          return (service = null);
        }
      "
    />

    <SendReportClient
      :show="showSendReportForm"
      :task_id="service ? service.id : null"
      v-on:close="
        () => {
          showSendReportForm = false;
          return (service = null);
        }
      "
      v-on:addedReport="
        () => {
          showSendReportForm = false;
          calendarApi.refetchEvents();
          return (service = null);
        }
      "/>

    <ShowAllParts
      :currentDate="currentDate"
      :show="showAllPartsDialog"
      @close="showAllPartsDialog = false"
    />

    <ShowAllLocations
      :currentDate="currentDate"
      :userId="userId"
      :show="showAllLocationsDialog"
      @close="showAllLocationsDialog = false"
    />

    <ShowAllVehicles
      :show="showAllVehicles"
      :date="vehicleReservationDate"
      :userId="userId"
      @close="closeVehicles"
      @reserved="onVehicleReserved"
      @cancelled="refreshVehicleReservation"
    />

    <PickupReception
      :show="showPickupReception"
      :service="service"
      v-on:close="
        () => {
          showPickupReception = false;
          pendingCheckoutTaskId = null;
          return (service = null);
        }
      "
      v-on:savedReception="onPickupReceptionSaved"
    />

    <Dialog
      id="'calendarGoTo'"
      :visible.sync="calendarGoTo"
      :style="{ width: $isMobile() ? '100vw' : '35vw' }"
      :modal="true"
      :header="'Ir para dia'"
      :closable="true"
      :dismissableMask="true"
      :position="$isMobile() ? 'top' : 'center'"
    >
      <div class="p-col-12 p-text-center">
        <v-calendar @dayclick="goDate" />
      </div>
    </Dialog>

    <FullCalendar ref="fullCalendar" :options="calendarOptions">
      <template v-slot:eventContent="arg">
        <div class="p-fluid p-formgrid p-grid">
          <div class="event-unavailable" v-if="arg.event._def.extendedProps.isHoliday">
            <div class="p-col-12 p-text-center"><b>Feriado:</b> {{ arg.event.title }}</div>
          </div>
          <div class="p-fluid p-formgrid p-grid event-unavailable" v-else-if="arg.event._def.extendedProps.inVacation">
            <div class="p-col-12 p-text-center">
              <b>Férias</b> {{ arg.event.title }}
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid event-unavailable" v-else-if="arg.event._def.extendedProps.missed">
            <div class="p-col-12"><b>Falta:</b> {{ arg.event.title }}</div>
          </div>
          <div class="p-fluid p-formgrid p-grid event-unavailable" v-else-if="arg.event._def.extendedProps.taskInfo.isBooking">
            <div class="event-container-time p-col-2"
              :class="{ 'success' : arg.event._def.extendedProps.taskInfo.finished }">
              <div class="event-container-time-justify">
                <div>
                  {{ formatTime(arg.event.start) }}
                  <div v-if="arg.event._def.hasEnd">
                      {{ formatTime(arg.event.end) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-10">
              <div class="p-mb-1 p-font-bold p-text-center">
                <b v-if="arg.event._def.extendedProps.taskInfo.type == 1">Reserva</b>
                <b v-if="arg.event._def.extendedProps.taskInfo.type == 2">Indisponível</b>
              </div>
              <div v-if="arg.event._def.extendedProps.taskInfo.note != ''">
                <b>Nota: </b>
                {{ arg.event._def.extendedProps.taskInfo.note }}
              </div>
            </div>
          </div>
          <div class="event-container-agenda" v-else>
            <div class="event-container-time p-col-2"
              :class="{ 'success' : arg.event._def.extendedProps.taskInfo.finished }">
              <div class="event-container-time-justify">
                <div>
                  {{ formatTime(arg.event.start) }}
                  <div v-if="arg.event._def.hasEnd">
                      {{ formatTime(arg.event.end) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="event-container-content p-col-10">
              <div v-if="arg.event._def.hasEnd">
                <i class="pi pi-clock"></i> {{ calculateDuration(arg.event.start, arg.event.end) }}
              </div>
              <div class="p-mt-1">
                PAT <b>{{ arg.event._def.extendedProps.taskInfo.pat_number }}</b>
                <b v-if="arg.event._def.extendedProps.taskInfo.pat_brand != ''">
                  | {{ arg.event._def.extendedProps.taskInfo.pat_brand }}</b
                >
                <b v-if="arg.event._def.extendedProps.taskInfo.pat_model != ''">
                  | {{ arg.event._def.extendedProps.taskInfo.pat_model }}</b
                >
              </div>
              <div
                v-if="arg.event._def.extendedProps.taskInfo.pat_title != ''"
              >
                {{ arg.event._def.extendedProps.taskInfo.pat_title }}
              </div>
              <divider />
              <div
                v-if="arg.event._def.extendedProps.taskInfo.entity_name != ''"
              >
                {{ arg.event._def.extendedProps.taskInfo.entity_name }}
              </div>
              <div v-else>
                {{ arg.event._def.extendedProps.taskInfo.contact_name }}
              </div>
              <div
                v-if="
                  arg.event._def.extendedProps.taskInfo.localization.address !=
                    undefined &&
                  (arg.event._def.extendedProps.taskInfo.localization.address !=
                    '' ||
                    arg.event._def.extendedProps.taskInfo.localization
                      .zip_code != '' ||
                    arg.event._def.extendedProps.taskInfo.localization.local !=
                      '')
                "
              >
                {{ arg.event._def.extendedProps.taskInfo.localization.address }}
                <p
                  v-if="
                    arg.event._def.extendedProps.taskInfo.localization
                      .zip_code != '' ||
                    arg.event._def.extendedProps.taskInfo.localization.local !=
                      ''
                  "
                >
                  {{
                    arg.event._def.extendedProps.taskInfo.localization.zip_code
                  }}
                  {{ arg.event._def.extendedProps.taskInfo.localization.local }}
                </p>
              </div>
              <div>
                <divider />
                <span class="p-d-flex p-ai-center">
                  <i class="pi pi-tag p-mr-1 p-text-secondary"></i>
                  <span class="p-d-flex p-flex-column p-ml-2">
                    <span v-if="arg.event._def.extendedProps.taskInfo.pat_transport_document_code">
                      <b>Guia de Transporte:</b>
                      {{ arg.event._def.extendedProps.taskInfo.pat_transport_document_code }}
                    </span>
                    <span>
                      <b>Estado do PAT:</b>
                      <span class="p-badge p-component p-ml-2"
                      :style="{
                          backgroundColor: arg.event._def.extendedProps.taskInfo.color_status,
                          color: getReadableTextColor(arg.event._def.extendedProps.taskInfo.color_status)
                        }">
                        {{ arg.event._def.extendedProps.taskInfo.pat_status }}
                      </span>
                    </span>
                    <span class="p-mt-1">
                      <b>Estado da Tarefa:</b>
                      <span class="uppercase">
                        {{
                          arg.event._def.extendedProps.taskInfo.status
                            .status_description
                        }}
                      </span>
                    </span>
                    <span class="p-mt-1">
                      <b>Estado do Equipamento:</b>
                      {{
                        arg.event._def.extendedProps.taskInfo.equipament_status
                      }}
                    </span>
                  </span>
                </span>
              </div>
              <div>
                <divider />
                <span class="p-d-flex p-ai-center">
                  <span class="p-d-flex p-flex-column p-ml-2">
                    <span class="p-badge p-component"
                      :class="arg.event.extendedProps.taskInfo.marcada ? 'p-badge-success' : 'p-badge-warning'">
                      <i class="pi pi-font-size"
                        :class="arg.event.extendedProps.taskInfo.marcada ? 'pi-check' : 'pi-times'"></i>
                      {{ arg.event.extendedProps.taskInfo.marcada ? 'Confirmado' : 'Não Confirmado' }}
                    </span>
                  </span>
                </span>
                <divider v-if="arg.event._def.extendedProps.taskInfo.note" />
                <p v-if="arg.event._def.extendedProps.taskInfo.note">
                  {{ arg.event._def.extendedProps.taskInfo.note }}
                </p>
              </div>


              <div
                v-if="!arg.event._def.extendedProps.taskInfo.isBooking"
                class="event-container-button-content"
              >
                <divider />
                <div class="event-container-button-group" v-bind:class="[{ 'p-d-flex': !$isMobile() }]">
                  <Button
                    label="INFO"
                    icon="pi pi-info-circle"
                    class="p-button-raised p-button-secondary p-button-sm p-button-warning"
                    @click="showTaskInfo(arg.event.id)"
                  />

                  <Button v-if="arg.event._def.extendedProps.taskInfo.finished"
                    label="ASSINATURA"
                    icon="pi pi-pencil"
                    class="p-button-raised p-button-sm"
                    @click="showSignaturePadReport(arg.event.id)"
                  />

                  <PreviewReport v-if="arg.event._def.extendedProps.taskInfo.status.report_file_url"
                    :filename="arg.event._def.extendedProps.taskInfo.status.report_file_url"
                  />

                  <Button v-if="arg.event._def.extendedProps.taskInfo.status.report_file_url"
                    label="ENVIAR RELATÓRIO"
                    icon="pi pi-envelope"
                    class="p-button-raised p-button-secondary p-button-sm p-button-success"
                    @click="showSendReportModal(arg.event.id)"
                  />

                  <template
                    v-if="
                      arg.event._def.extendedProps.taskInfo.is_today &&
                      !arg.event._def.extendedProps.taskInfo.finished
                    "
                  >
                    <SplitButton
                      v-if="
                        inWork &&
                        arg.event._def.extendedProps.taskInfo.status.status ==
                          4 &&
                        arg.event._def.extendedProps.taskInfo.running
                      "
                      appendTo="body"
                      label="Check Out"
                      icon="pi pi-sign-out"
                      v-bind:class="[
                        { 'p-mt-1': $isMobile() },
                        'p-button-raised p-button-success p-button-sm',
                      ]"
                      @click.prevent="() => checkOut(arg.event.id, 'PRONTO')"
                      :model="[
                        {
                          label: 'Concluir',
                          icon: 'pi pi-check-square',
                          command: () => checkOut(arg.event.id, 'PRONTO'),
                        },
                        {
                          label: 'Recolha',
                          icon: 'pi pi-truck',
                          command: () => checkOut(arg.event.id, 'RECOLHIDO'),
                        },
                        {
                          label: 'Reagendar',
                          icon: 'pi pi-calendar',
                          command: () => checkOut(arg.event.id, 'TRIAGEM'),
                        },
                      ]"
                    />
                    <Button
                      v-if="
                        !inWork &&
                        arg.event._def.extendedProps.taskInfo.status.status == 0
                      "
                      label="Iniciar deslocação"
                      icon="pi pi-car"
                      class="p-button-raised p-button-secondary p-button-sm"
                      @click="confirmStartTask(arg.event.id)"
                    >
                    </Button>
                    <Button
                      v-if="
                        inWork &&
                        arg.event._def.extendedProps.taskInfo.status.status ==
                          1 &&
                        arg.event._def.extendedProps.taskInfo.running
                      "
                      label="Reverter Início"
                      icon="pi pi-check-square"
                      class="p-button-raised p-button-danger p-button-sm p-mr-1"
                      @click="confirmRevertStartTask(arg.event.id)"
                    />
                    <Button
                      v-if="
                        inWork &&
                        arg.event._def.extendedProps.taskInfo.status.status ==
                          1 &&
                        arg.event._def.extendedProps.taskInfo.running
                      "
                      label="Check In"
                      icon="pi pi-check-square"
                      class="p-button-raised p-button-secondary p-button-sm p-mr-1"
                      @click="confirmStartService(arg.event.id)"
                    />
                    <Button
                      v-if="
                        inWork &&
                        arg.event._def.extendedProps.taskInfo.running &&
                        arg.event._def.extendedProps.taskInfo.status.status > 1
                      "
                      :label="
                        arg.event._def.extendedProps.taskInfo.status.status == 2
                          ? 'Confirmar Dados do Equipamento'
                          : 'Dados do Equipamento'
                      "
                      icon="pi pi-list"
                      class="p-button-raised p-button-secondary p-button-sm p-mr-1"
                      @click="showCheckData(arg.event.id)"
                    />
                    <Button
                      v-if="
                        inWork &&
                        arg.event._def.extendedProps.taskInfo.status.status ==
                          3 &&
                        arg.event._def.extendedProps.taskInfo.running
                      "
                      label="Fotos Equipamento"
                      icon="pi pi-camera"
                      class="p-button-raised p-button-secondary p-button-sm"
                      @click="addPhotos(arg.event.id)"
                    />
                    <Button
                      v-if="
                        inWork &&
                        arg.event._def.extendedProps.taskInfo.status.status ==
                          4 &&
                        arg.event._def.extendedProps.taskInfo.running
                      "
                      label="Aplicar Peça"
                      icon="pi pi-wrench"
                      class="p-button-raised p-button-secondary p-button-sm p-mr-1"
                      @click="addPart(arg.event.id)"
                    />
                    <Button
                      v-if="
                        inWork &&
                        arg.event._def.extendedProps.taskInfo.status.status ==
                          4 &&
                        arg.event._def.extendedProps.taskInfo.running
                      "
                      label="Fotos"
                      icon="pi pi-camera"
                      class="p-button-raised p-button-secondary p-button-sm p-mr-1"
                      @click="addExtraPhotos(arg.event.id)"
                    />
                  </template>
                </div>
              </div>

            </div>
          </div>

        </div>
      </template>
      <template v-slot:dayHeaderContent="arg">
        <span class="p-md-10 p-text-left">
          {{ arg.text }} - {{ new Date(arg.date).getDate() }}/{{
            new Date(arg.date).getMonth() + 1
          }}/{{ new Date(arg.date).getFullYear() }}
        </span>
      </template>
    </FullCalendar>
  </div>
</template>

<script>
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import ptLocale from "@fullcalendar/core/locales/pt";
import SplitButton from "primevue/splitbutton";
import { getOnlyDate, hexToRGB, isToday } from "../helpers/helpers";
import taskService from "../services/task.service";
import supportService from "../services/support.service";
import userService from "../services/user.service";
import { getBaseLocation, calculateRoundTrip, hasCoords } from "../helpers/routeDistance";
import ConfirmEquipamentData from "../components/support/ConfirmEquipamentData.vue";
import EquipamentPhotos from "../components/support/EquipamentPhotos.vue";
import ExtraPhoto from "../components/support/ExtraPhoto.vue";
import InterventionInfo from "../components/support/InterventionInfo.vue";
import AddPart from "../components/support/AddPart.vue";
import WorkSheet from "../components/support/WorkSheet.vue";
import SignaturePadReport from "../components/support/SignaturePadReport.vue";
import SendReportClient from "../components/support/SendReportClient.vue";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import PreviewReport from "../components/elements/PreviewReport.vue";
import ShowAllParts from "../components/support/ShowAllParts.vue";
import ShowAllLocations from "../components/support/ShowAllLocations.vue";
import ShowAllVehicles from "../components/support/ShowAllVehicles.vue";
import PickupReception from "../components/support/PickupReception.vue";
import chroma from "chroma-js";

export default {
  name: "TaskList",
  components: {
    Loading: loading,
    SplitButton,
    ConfirmEquipamentData,
    EquipamentPhotos,
    InterventionInfo,
    AddPart,
    WorkSheet,
    ExtraPhoto,
    SignaturePadReport,
    PreviewReport,
    SendReportClient,
    ShowAllParts,
    ShowAllLocations,
    ShowAllVehicles,
    PickupReception,
  },
  data() {
    return {
      calendarHeaderDirection: this.$isMobile() ? "column" : "row",
      service: null,
      userId: null,
      calendarApi: null,
      calendarOptions: null,
      isLoading: true,
      inWork: false,
      calendarGoTo: false,
      showInfo: false,
      showConfirmDataForm: false,
      showFotosForm: false,
      showExtraFotosForm: false,
      showAddPartForm: false,
      showReportForm: false,
      showSignaturePadReportForm: false,
      showSendReportForm: false,
      workSheet: {
        show: false,
        taskId: null,
        newStatus: null,
      },
      showAllPartsDialog: false,
      showAllLocationsDialog: false,
      showAllVehicles: false,
      vehicleReservationDate: getOnlyDate(new Date()),
      showPickupReception: false,
      pendingCheckoutTaskId: null,
      pendingDepartureTaskId: null,
      startingTask: false,
      hasVehicleReservation: null,
      reservationError: "",
      reservationRequestSequence: 0,
      agendaRequestSequence: 0,
      calculatingDistance: false,
      totalDistanceKm: null,
      distanceIsEstimate: false,
      missingCoordsCount: 0,
      baseLocation: null,
    };
  },
  created() {
    this.today = getOnlyDate(new Date());
    this.userId = this.$store.state.auth.user.id;
  },
  beforeMount() {
    this.generateCalendar();
  },
  mounted() {
    this.calendarApi = this.$refs.fullCalendar.getApi();
  },
  computed: {
    requireReservation() {
      return this.hasVehicleReservation === false && this.vehicleReservationDate === getOnlyDate(new Date());
    },
    currentDate() {
      if (!this.calendarApi) return "";
      const date = this.calendarApi.getDate();

      return date.toLocaleDateString('pt-PT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-');
    }
  },
  activated() {
    this.calendarApi.refetchEvents();
  },
  beforeDestroy() {
    this.agendaRequestSequence++;
    this.reservationRequestSequence++;
  },
  methods: {
    async refreshVehicleReservation() {
      const sequence = ++this.reservationRequestSequence;
      this.reservationError = "";
      try {
        const reservations = await userService.getMyVehicles();
        if (this._isDestroyed || sequence !== this.reservationRequestSequence) return;
        if (!Array.isArray(reservations)) throw new Error("Invalid vehicle reservations");
        this.hasVehicleReservation = reservations.some((reservation) =>
          reservation.end === null && reservation.vehicle && Number(reservation.vehicle.active) === 1
        );
      } catch (error) {
        if (this._isDestroyed || sequence !== this.reservationRequestSequence) return;
        this.hasVehicleReservation = null;
        this.reservationError = "Não foi possível validar a reserva do veículo. Atualize a agenda.";
      }
    },
    async calculateAgendaDistance(days, date, sequence) {
      const base = getBaseLocation(this.$store.state.auth.user);
      this.baseLocation = base;
      const tasks = days.filter((day) => day.day === date).flatMap((day) => day.tasks || [])
        .filter((task) => !task.isBooking)
        .sort((a, b) => String(a.start || "").localeCompare(String(b.start || "")));
      const stops = tasks.map((task) => task.localization).filter(hasCoords)
        .map((loc) => ({ lat: loc.latitude, lng: loc.longitude }));
      this.missingCoordsCount = tasks.length - stops.length;
      if (!base || !stops.length) return;
      this.calculatingDistance = true;
      try {
        const result = await calculateRoundTrip(base, stops);
        if (this._isDestroyed || sequence !== this.agendaRequestSequence) return;
        this.totalDistanceKm = result.km;
        this.distanceIsEstimate = result.isEstimate;
      } catch (error) {
        if (sequence === this.agendaRequestSequence) {
          this.$toast.add({ severity: "warn", summary: "Não foi possível calcular a distância do dia.", group: "taskList", life: 3000 });
        }
      } finally {
        if (sequence === this.agendaRequestSequence) this.calculatingDistance = false;
      }
    },
    formatTime(date) {
      return new Date(date).toLocaleTimeString('pt-PT', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    },
    calculateDuration(start, end) {
      const diff = new Date(end) - new Date(start);
      const minutes = Math.floor(diff / 60000);
      if (minutes < 60) {
        return `${minutes} min`;
      }
      const hours = Math.floor(minutes / 60);
      const remainingMins = minutes % 60;
      return remainingMins > 0 ? `${hours}h ${remainingMins}min` : `${hours}h`;
    },
    generateCalendar() {
      const calendarGoTo = () => (this.calendarGoTo = true);
      const toggleAllParts = () => (this.showAllPartsDialog = true);
      const toggleAllLocations = () => (this.showAllLocationsDialog = true);
      const toggleAllVehicles = () => (this.showAllVehicles = true);

      this.calendarOptions = {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        locale: ptLocale,
        allDaySlot: false,
        selectable: true,
        firstDay: 1,
        height: 700,
        scrollTime: "09:00",
        slotDuration: "00:15",
        slotLabelInterval: "01:00",
        slotLabelFormat: {
          hour: "numeric",
          minute: "2-digit",
          omitZeroMinute: false,
          meridiem: "short",
        },
        initialView: "listDay",
        datesSet: (info) => {
          this.vehicleReservationDate = getOnlyDate(info.view.calendar.getDate());
        },
        displayEventTime: false,
        displayEventEnd: false,
        editable: true,
        customButtons: {
          showCalendar: {
            text: "IR PARA",
            click: function () {
              calendarGoTo();
            },
          },
          seeParts: {
            text: "PEÇAS",
            click: function () {
              toggleAllParts();
            },
          },
          seeLocations: {
            text: "LOCAIS",
            click: function () {
              toggleAllLocations();
            },
          },
          seeVehicles: {
            text: "VEÍCULOS",
            click: function () {
              toggleAllVehicles();
            },
          },
        },
        titleFormat: {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        },
        headerToolbar: {
          left: "prev,today,next showCalendar",
          center: "title",
          right: "seeParts seeLocations seeVehicles",
        },
        buttonText: {
          listDay: "Por Dia",
          listWeek: "Por Semana",
        },
      };
      const getTasks = (dateStart, dateEnd) =>
        this.getUserTasks(dateStart, dateEnd);

      this.calendarOptions.events = function (info, successCallback) {
        getTasks(getOnlyDate(info.start), getOnlyDate(info.end)).then(
          (tasks) => {
            successCallback(tasks);
          }
        );
      };
    },
    getUserTasks(dateStart, dateEnd) {
      const sequence = ++this.agendaRequestSequence;
      this.isLoading = true;
      this.calculatingDistance = false;
      this.totalDistanceKm = null;
      this.distanceIsEstimate = false;
      this.missingCoordsCount = 0;
      this.refreshVehicleReservation();
      this.removeAllTasks();
      return taskService
        .getTasksAndBookings(this.userId, dateStart, dateEnd)
        .then((days) => {
          if (this._isDestroyed || sequence !== this.agendaRequestSequence) return [];
          let userTasks = [];
          if (!days) {
            this.isLoading = false;
            return userTasks;
          }
          days.forEach((day) => {
            if (day.isHoliday || day.inVacation || day.missed) {
              let backgroundTask = {
                start: `${day.day} 00:00`,
                end: `${day.day} 23:59`,
                isHoliday: false,
                inVacation: false,
                missed: false,
                taskInfo: {
                  is_today: false,
                },
              };
              if (day.isHoliday) {
                backgroundTask.title = day.isHoliday;
                backgroundTask.isHoliday = true;
              } else if (day.inVacation) {
                backgroundTask.title = "";
                if (!day.inVacation.approved) {
                  backgroundTask.title = "(Não Aprovada)";
                }
                backgroundTask.inVacation = true;
                backgroundTask.color = "#33ff00";
              } else if (day.missed) {
                backgroundTask.title = day.missed;
                backgroundTask.missed = true;
                backgroundTask.color = "#ff0000";
              }
              userTasks.push(backgroundTask);
            }
            day.tasks.forEach((task) => {
              if (task.isBooking != undefined && task.isBooking) {
                task["is_today"] = isToday(
                  new Date(`${task.date} ${task.start}`)
                );
                task["is_booking"] = true;
              } else {
                task["is_today"] = isToday(new Date(task.start));
                task["is_booking"] = false;
              }

              task["photos"] = false;
              task["confirmedData"] = false;
              task["running"] = false;
              task["finished"] = false;
              if (task.is_today && !task.is_booking) {
                if (task.status.status == 5) {
                  task.finished = true;
                } else if (task.status.status > 0 && task.status.status < 5) {
                  task.running = true;
                  this.inWork = true;
                }
              }
              userTasks.push({
                id: task.id,
                title: task.is_booking
                  ? "Reserva"
                  : `${task.pat_number} - ${task.pat_title}`,
                start: task.is_booking
                  ? `${task.date} ${task.start}`
                  : task.start,
                end: task.is_booking ? `${task.date} ${task.end}` : task.end,
                color: hexToRGB("#FFFFFF", 1),
                backgroundColor: "#000000",
                editable: false,
                taskInfo: task,
                borderColor: "blue",
                isBooking: task.is_booking,
              });
            });
          });

          this.isLoading = false;
          this.calculateAgendaDistance(days, dateStart, sequence);
          return userTasks;
        });
    },
    removeAllTasks() {
      if (!this.calendarApi) {
        return;
      }
      let events = this.calendarApi.getEvents();
      events.forEach((event) => {
        event.remove();
      });
    },
    confirmStartTask(taskId) {
      if (this.startingTask) return;
      let task = this.calendarApi.getEventById(taskId).extendedProps.taskInfo;
      let message = `Pretende iniciar a deslocação para o serviço do Pat ${task.pat_number} |
        ${task.pat_brand} | ${task.pat_model}, ${task.pat_problem} agora?`;

      this.$confirm.require({
        header: "Iniciar deslocação",
        message: message,
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          this.startTask(taskId);
        },
        reject: () => {
          this.$confirm.close();
        },
      });
    },
    confirmRevertStartTask(taskId) {
      let task = this.calendarApi.getEventById(taskId).extendedProps.taskInfo;
      let message = `Pretende reverter o início da deslocação para o serviço do Pat ${task.pat_number} |
        ${task.pat_brand} | ${task.pat_model}, ${task.pat_problem} agora?`;

      this.$confirm.require({
        header: "Reverter início da deslocação",
        message: message,
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          this.revertStartTask(taskId);
        },
        reject: () => {
          this.$confirm.close();
        },
      });
    },
    revertStartTask(taskId) {
      supportService.revertStartSupport(taskId).then((response) => {
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro ao reverter o início do serviço",
            detail: "",
            group: "taskList",
            life: 3000,
          });
        }
        this.inWork = false;
        this.calendarApi.refetchEvents();
        return this.$toast.add({
          severity: "success",
          summary: "Início do serviço revertido com sucesso",
          detail: "",
          group: "taskList",
          life: 3000,
        });
      });
    },
    closeVehicles() {
      this.showAllVehicles = false;
      this.pendingDepartureTaskId = null;
      this.refreshVehicleReservation();
    },
    onVehicleReserved() {
      const taskId = this.pendingDepartureTaskId;
      if (taskId === null) {
        this.refreshVehicleReservation();
        return;
      }
      this.closeVehicles();
      this.confirmStartTask(taskId);
    },
    async startTask(taskId) {
      if (this.startingTask) return;
      this.startingTask = true;
      try {
        const response = await supportService.startSupport(taskId);
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro ao iniciar o serviço",
            detail: "",
            group: "taskList",
            life: 3000,
          });
        }
        this.inWork = true;
        this.calendarApi.refetchEvents();
        return this.$toast.add({
          severity: "success",
          summary: "Serviço iniciado com sucesso",
          detail: "",
          group: "taskList",
          life: 3000,
        });
      } catch (error) {
        const data = error.response && error.response.data;
        if (data && data.code === "vehicle_reservation_required") {
          this.hasVehicleReservation = false;
          this.reservationError = "";
          this.pendingDepartureTaskId = taskId;
          this.vehicleReservationDate = getOnlyDate(new Date());
          this.showAllVehicles = true;
          return;
        }
        this.$toast.add({
          severity: "error",
          summary: "Erro ao iniciar a deslocação",
          detail: data && data.message || "Não foi possível iniciar a deslocação. Tente novamente.",
          group: "taskList",
          life: 5000,
        });
      } finally {
        this.startingTask = false;
      }
    },
    checkOut(taskId, status) {
      if (status === "RECOLHIDO") {
        supportService.checkReception(taskId).then((response) => {
          if (response && response.already_exists) {
            this.$toast.add({
              severity: "warn",
              summary: "Recepção já registada para esta tarefa",
              detail: "",
              group: "taskList",
              life: 3000,
            });
            this.confirmCheckOut(taskId, status);
          } else {
            let task = this.calendarApi.getEventById(taskId);
            this.service = task._def.extendedProps.taskInfo;
            this.pendingCheckoutTaskId = taskId;
            this.showPickupReception = true;
          }
        });
        return;
      }
      this.confirmCheckOut(taskId, status);
    },
    confirmCheckOut(taskId, status) {
      let message = `Pretende concluir a intervenção?`;
      if (status == "PRONTO") {
        message = `Pretende concluir a intervenção?`;
      } else if (status == "RECOLHIDO") {
        message = `Pretende recolher o equipamento?`;
      } else if (status == "TRIAGEM") {
        message = `Pretende reagendar nova intervenção?`;
      }
      this.$confirm.require({
        header: "Check Out",
        message: message,
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          this.validateWorkSheet(taskId, status);
        },
      });
    },
    validateWorkSheet(taskId, status) {
      return (this.workSheet = {
        show: true,
        taskId: taskId,
        newStatus: status,
      });
    },
    showCheckData(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      this.service = task.extendedProps.taskInfo;
      return (this.showConfirmDataForm = true);
    },
    addPhotos(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      this.service = task.extendedProps.taskInfo;
      return (this.showFotosForm = true);
    },
    addExtraPhotos(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      this.service = task.extendedProps.taskInfo;
      return (this.showExtraFotosForm = true);
    },
    addPart(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      this.service = task.extendedProps.taskInfo;
      return (this.showAddPartForm = true);
    },
    showSignaturePadReport(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      this.service = task.extendedProps.taskInfo;
      return (this.showSignaturePadReportForm = true);
    },
    showSendReportModal(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      this.service = task.extendedProps.taskInfo;
      return (this.showSendReportForm = true);
    },
    goDate(date) {
      this.calendarApi.gotoDate(date.id);
      this.calendarGoTo = false;
    },
    showTaskInfo(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      this.service = task._def.extendedProps.taskInfo;
      this.showInfo = true;
    },
    confirmStartService(taskId) {
      let message = `Deseja Efetuar o Check In?`;
      this.$confirm.require({
        header: "Check In",
        message: message,
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          this.startService(taskId);
        },
      });
    },
    startService(taskId) {
      supportService.startSupportService(taskId).then((response) => {
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro ao iniciar o serviço",
            detail: "",
            group: "taskList",
            life: 3000,
          });
        }

        let task = this.calendarApi.getEventById(taskId);
        let taskInfo = task._def.extendedProps.taskInfo;
        this.service = taskInfo;
        this.showConfirmDataForm = true;
        this.calendarApi.refetchEvents();
      });
    },

    changedStatus(info) {
      this.loading = true
      let task;
      if (info.status.status == 5) {
        task = this.calendarApi.getEventById(this.workSheet.taskId);
      } else {
        task = this.calendarApi.getEventById(this.service.id);
      }
      let taskInfo = task._def.extendedProps.taskInfo;
      taskInfo.status = info.status;
      this.showConfirmDataForm = false;
      if (info.status.status == 3) {
        this.showConfirmDataForm = false;
        this.showFotosForm = true;
      } else if (info.status.status == 4) {
        this.calendarApi.refetchEvents();
        this.showFotosForm = false;
      } else if (info.status.status == 5) {
        this.workSheet = {
          show: false,
          taskId: null,
          newStatus: null,
        };
        this.showReportForm = false;
        this.calendarApi.refetchEvents();
        this.loading = false;
        this.service = taskInfo;
        this.showSignaturePadReportForm = true;
        return (this.inWork = false);
      }
    },
    onPickupReceptionSaved() {
      this.showPickupReception = false;
      this.service = null;
      this.confirmCheckOut(this.pendingCheckoutTaskId, 'RECOLHIDO');
      this.pendingCheckoutTaskId = null;
    },
    endService() {
      this.loading = true
      let data = {
        status: this.workSheet.newStatus,
      };
      supportService
        .endService(this.workSheet.taskId, data)
        .then((response) => {
          this.loading = false;
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro ao Fazer o Check Out",
              detail: "Ocorreu um erro ao guardar a informação",
              life: 3000,
              group: "taskList",
            });
          }
          this.$toast.add({
            severity: "success",
            summary: "Check Out Efetuado com sucesso",
            detail: "O Check Out foi efetuado com sucesso",
            life: 3000,
            group: "taskList",
          });
          return this.changedStatus(response);
        });
    },
    getReadableTextColor(backgroundColor) {
      const whiteContrast = chroma.contrast(backgroundColor, "#ffffff");
      const blackContrast = chroma.contrast(backgroundColor, "#000000");
      return whiteContrast > blackContrast ? "#ffffff" : "#000000";
    },
  },
};
</script>

<style>
.agenda-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.agenda-summary h4, .agenda-summary .p-message { margin: 0; }
.agenda-summary .p-tag { white-space: normal; }
.agenda-distance { flex-wrap: wrap; gap: 0.25rem; }
.agenda-distance small { font-weight: normal; }
.agenda-reservation-message { flex: 1 1 240px; }

.fc-event-main {
  background: rgba(255, 255, 255, 0) !important;
  background-color: rgba(255, 255, 255, 0) !important;
  border: 0px !important;
}

.fc-scrollgrid-shrink,
.fc-scrollgrid-shrink + td {
  border-top-width: 3px !important;
}

.fc .fc-list-day th {
  background: #ff4910 !important;
  color: #fff;
  z-index: 500;
}

.fc .fc-list-event-graphic {
  display: none !important;
}

.fc .fc-list-event-time {
  white-space: unset !important;
  word-wrap: break-word !important;
  min-width: 60px !important;
  width: auto !important;
}
.fc .fc-list-table td,
.fc .fc-list-day-cushion {
  padding: 0px !important;
}

.stop {
  width: 10px;
  height: 10px;
  background-color: #fff;
}

.play {
  font-size: 22px;
  margin-left: 3px;
  margin-bottom: 1px;
}

.p-confirm-dialog {
  z-index: 90000 !important;
}
.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
  display: flex;
  flex-direction: v-bind(calendarHeaderDirection);
  flex-wrap: wrap;
}

.fc .fc-toolbar-title {
    font-size: 1.50em;
    margin: 0;
}

.event-container-content {
  background: #f6f6f6;
  padding-top: 5px !important;
  padding-bottom: 10px !important;
}

.event-container-agenda {
  display: flex;
  width: 100%;
}

.event-container-time {
  border-right: 5px solid;
  border-right: 5px solid;
  border-color:  #888;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}

.event-container-time.success {
  border-color:  #28a745!important;
}

.event-container-time-justify {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}

.pi-font-size {
  font-size: 0.75rem;
}

.event-unavailable {
  display: flex;
  justify-content: center;
  padding: 10px;
  background: #cacaca;
  text-transform: uppercase;
  width: 100%;
}


.event-container-button-content {
  margin: 5px;
}

.event-container-button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.event-container-button-group > * {
  flex: 1 1 calc(50% - 8px);
  white-space: normal !important;
  word-wrap: break-word !important;
}

.fc-seeParts-button {
  background-color: #ffc107 !important;
  color: #000 !important;
  border: none !important;
}

.fc-seeVehicles-button {
  background-color: #0a8d3a !important;
  color: #fff !important;
  border: none !important;
}

.fc-seeLocations-button {
  background-color: #17a2b8 !important;
  color: #fff !important;
  border: none !important;
}

@media (max-width: 768px) {
  .event-container-button-group {
    gap: 6px;
  }

  .event-container-button-group > * {
    flex: 1 1 calc(50% - 6px);
    min-width: 0;
  }
}

@media (max-width: 480px) {
  .event-container-button-group > * {
    flex: 1 1 100%;
  }
}

</style>
